module.exports = __webpack_public_path__ + "img/finish.e0ef4d31.svg";